import { motivosForSucursalDepartamento } from "./motivosForSucursalDepartamento";

export const submotivosForSucursalDepartamento = (motivos, formik) => {
  const existentIds = [];

  return (
    motivosForSucursalDepartamento(motivos, formik)
      // Extraigo los submotivos de los motivos
      .reduce((submotivosList, motivo) => submotivosList.concat(motivo.Submotivos), [])
      // Filtro duplicados
      .filter((submotivo) => {
        if (submotivo === null || existentIds.includes(submotivo.itemId)) {
          return false;
        }
        existentIds.push(submotivo.itemId);
        return true;
      })
  );
};
